import { TypeImage } from "@contentful/types";
import { cn } from "@yardzen/ui/lib/utils";
import Image from "next/image";

export function ImageCollectionGrid({
  images,
}: {
  images: TypeImage<"WITHOUT_UNRESOLVABLE_LINKS">[];
}) {
  return (
    <div className="flex flex-wrap justify-center gap-2 sm:justify-around sm:gap-6">
      {images?.map((image, index) => (
        <div
          key={`ImageCollectionGrid-${image?.sys.id}-${index}`}
          className="w-[44%]"
        >
          <Image
            src={`https:${image?.fields?.image?.fields?.file?.url}`}
            alt={image?.fields?.image?.fields?.description ?? ""}
            height={400}
            width={400}
            className={cn("h-full w-full object-cover")}
            loading="lazy"
          />
        </div>
      ))}
    </div>
  );
}
